'use strict';

namespace Core {
    class BasicContentCard {
        // Attr
        click: () => void;
        header: string;
        overlay: string;
        imageUrl: string;
        href: string;
        contentCardClass: string;
    }
    angular
        .module('core')
        .directive('basicContentCard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: BasicContentCard,
                controllerAs: 'bcc',
                transclude: true,
                bindToController: {
                    click: '&',
                    header: '@',
                    overlay: '@',
                    imageUrl: '@',
                    href: '@',
                    contentCardClass: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=BasicContentCard'
            };
        });
}
